import apiClient from '@/services/axios'
import utilities from '@/services/utilities'

export async function getAll(payload) {
	return new Promise((resolve, reject) => {
		return apiClient
			.post('/warehouse/cashflow', payload)
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}

export async function create(payload) {
	return new Promise((resolve, reject) => {
		return apiClient
			.post('/warehouse/cashflow/create', payload)
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				// console.log(err)
				reject(err)
			})
	})
}

export async function budgetAllocation(payload) {
	return new Promise((resolve, reject) => {
		return apiClient
			.post('/warehouse/cashflow/budget-allocation', payload)
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				// console.log(err)
				reject(err)
			})
	})
}

export async function loanFunding(payload) {
	return new Promise((resolve, reject) => {
		return apiClient
			.post('/warehouse/cashflow/loan-funding', payload)
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				// console.log(err)
				reject(err)
			})
	})
}

export async function getLoanHistory(payload) {
	return new Promise((resolve, reject) => {
		return apiClient
			.post('/warehouse/cashflow/loan-history', payload)
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				// console.log(err)
				reject(err)
			})
	})
}

export async function getFileUrl(fileId) {
	return new Promise((resolve, reject) => {
		return apiClient
			.get(`/warehouse/cashflow/file/${fileId}`)
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}
